
export const UserStatus = {
  Active: 'Active',
  Deactivated: 'Deactivated',
  InviteExpired: 'Invitation Expired',
  PendingUserAcceptance: 'Pending User Acceptance',
}

export const Labels = {
  sendInvite: 'Send Invite',
  sendingInvitation: 'Sending Invitation'
}

export const Messages = {
  InvitationPrevioslySent: 'Invitation oreviously sent on '
}

export const SearchByEnum =
{
  Status: '0',
  FirstName: '1',
  LastName: '2',
  Email: '3',
  Role: '4',
  All: '5'
}

export const UserStatusEnum =
{
  Approved: '1',
  Denied: '2',
  InviteSent: '3',
  Active: '4',
  Deactivated: '5',
  InviteExpired: '6',
  PendingApproval: '7',
  PendingUserRegistration: '8',
  PendingUserAcceptance: '9'
}

export const RoleEnum =
{
  Administrator: '1',
  Director: '2'
}

export const UserListHeaders = [
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'National Id', key: 'usbcMembershipId' },
  { label: 'Email Address', key: 'emailAddress' },
  { label: 'Role', key: 'role' },
  { label: 'SSOUserId', key: 'ssoUserId' },
  { label: 'Status', key: 'status' },
]


// WEBPACK FOOTER //
// ./src/components/pages/UserManagement/constants.js